module.exports = __webpack_public_path__ + "static/media/6-emily-bday-08_03_2020.1ad268a3.jpg";